import React, { useEffect, useState } from 'react';
import { ContactFormConnector } from '../../../services/connectors/ContactFormConnector';

const FormSecurityToken: React.FC = () => {
  const contactFormConnector = new ContactFormConnector();
  const [token, setToken] = useState('');

  useEffect(() => {
    contactFormConnector.requestFormSecurityToken().then(({ token }) => {
      setToken(token);
    });
  }, []);

  return <input name="formSecurityToken" type="text" hidden defaultValue={token} />;
};

export default FormSecurityToken;
